import { publicApi } from "@/lib/api";

// Cookie-free, pseudonymous measurement: a random id in local storage, never linked to invoice data.
const vid = () => {
  let v = localStorage.getItem("ir_vid");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("ir_vid", v); }
  return v;
};

const attribution = () => {
  const p = new URLSearchParams(window.location.search);
  const stored = JSON.parse(sessionStorage.getItem("ir_attr") || "null");
  if (stored && !p.get("utm_source")) return stored;
  const ref = document.referrer && !document.referrer.includes(window.location.host) ? document.referrer : "";
  const source = p.get("utm_source") || (p.get("utm_medium") === "email" ? "email campaign" : ref.match(/google|bing|duckduckgo/) ? "search" : ref ? "referral" : "direct");
  const a = { source, campaign: p.get("utm_campaign") || "", voucher: p.get("voucher") || "" };
  sessionStorage.setItem("ir_attr", JSON.stringify(a));
  return a;
};

export const visitorId = vid;
const internal = () => localStorage.getItem("ir_internal") === "1";

export function track(name, extra = {}) {
  if (internal()) return;
  const device = window.innerWidth < 768 ? "mobile" : window.innerWidth < 1100 ? "tablet" : "desktop";
  publicApi("post", "/t", { name, vid: vid(), path: window.location.pathname, device, ...attribution(), ...extra }).catch(() => {});
}

export function trackPage() {
  track("visit");
  let max = 0;
  const onScroll = () => {
    const d = Math.round(((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100);
    max = Math.max(max, Math.min(100, d));
  };
  const onClick = (e) => {
    const t = e.target.closest("[data-testid]");
    if (t) track("click", { target: t.getAttribute("data-testid").slice(0, 80) });
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  document.addEventListener("click", onClick);
  return () => {
    if (max) track("scroll", { depth: max });
    window.removeEventListener("scroll", onScroll);
    document.removeEventListener("click", onClick);
  };
}

export const markInternal = () => localStorage.setItem("ir_internal", "1");
